module.exports = __webpack_public_path__ + "static/media/upload4.39166e3a.png";